import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import PostHooks from "../../Api/PostHooks";
import { LoadingButton } from "@mui/lab";
import { getUserDetails } from "../../utils/helpers";
import { useEffect } from "react";

const CreatePoolBasket = ({ user, onClose, onSuccess }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const LoggedInUser = getUserDetails();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [loading, response, request] = PostHooks();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const onSubmit = async (e) => {
    try {
      let formData = {
        entity_id: LoggedInUser?.id,
        name: e.name,
      };

      const createResp = await request({
        url: "pool_fund_basket",
        body: formData,
      });

      if (
        createResp &&
        createResp.status === 200 &&
        createResp.data.StatusCode === 0
      ) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Pool basket created successfully!",
        });

        setTimeout(() => {
          onClose();
          onSuccess();
        }, 1000);
      } else {
        const errorMessage =
          createResp?.data?.StatusMessage ??
          createResp?.data?.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormControl
        fullWidth
        error={!!errors.name}
        sx={{
          mt: "5px",
        }}
      >
        <InputLabel htmlFor="name">Name</InputLabel>
        <OutlinedInput
          id="name"
          {...register("name", { required: true })}
          label="Name"
          xs={12}
          variant="filled"
        />
        {errors.first_name && <FormHelperText>Required</FormHelperText>}
      </FormControl>

      <Box
        sx={{
          pt: "20px",
          gap: "20px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button
          variant="outlined"
          size="large"
          type="reset"
          onClick={() => onClose()}
        >
          cancel
        </Button>

        <LoadingButton
          variant="contained"
          sx={{ ml: "10px" }}
          size="large"
          type="submit"
          loading={loading}
        >
          Create
        </LoadingButton>
      </Box>
    </form>
  );
};

export default CreatePoolBasket;
